// dashboardWidgetRegistryConfig/insightsWidgetLayout.config.ts
export type InsightsWidgetSize = "full" | "half" | "third";

export interface InsightsWidgetLayout {
  menuId: number;
  size: InsightsWidgetSize;
}

export const INSIGHTS_WIDGET_LAYOUT: InsightsWidgetLayout[] = [
  { menuId: 208, size: "full" }, // CFO Insights Daily Brief
  { menuId: 209, size: "third" }, // Liquidity
  { menuId: 210, size: "third" }, // Attention
  { menuId: 211, size: "third" }, // Opportunity
  { menuId: 212, size: "half" }, // Spend By Category
  { menuId: 213, size: "half" }, // Inflow vs Outflow
  { menuId: 214, size: "full" }, // Top Beneficiaries
];
